import React, {FC, useEffect} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useFormik} from 'formik'
import {ILocationModel, initialLocation, validationLocation} from './LocationModel'

type Props = {
  show: boolean
  editingItem: ILocationModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (location: ILocationModel) => void
}

export const LocationFormModal: FC<Props> = ({show, editingItem, loading, onClose, onSubmit}) => {
  const isEditing = !!editingItem

  const formik = useFormik<ILocationModel>({
    initialValues: initialLocation,
    validationSchema: validationLocation,
    onSubmit: (values) =>
      onSubmit({...values, province: values.province.trim(), district: values.district.trim()}),
  })

  // Modal her açıldığında formu yeni kayıt / düzenlenen kayıt ile doldur
  useEffect(() => {
    if (!show) return
    formik.resetForm({
      values: editingItem
        ? {id: editingItem.id, province: editingItem.province, district: editingItem.district}
        : initialLocation,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, editingItem])

  const fieldClass = (field: 'province' | 'district') =>
    `form-control ${formik.touched[field] && formik.errors[field] ? 'is-invalid' : ''}`

  return (
    <Modal show={show} onHide={onClose} dialogClassName='modal-dialog-centered' backdrop='static'>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-header'>
          <h5 className='modal-title'>{isEditing ? 'Lokasyon Düzenle' : 'Yeni Lokasyon'}</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>

        <div className='modal-body'>
          <div className='mb-5'>
            <label className='form-label fw-bold required'>İl</label>
            <input
              type='text'
              autoFocus
              className={fieldClass('province')}
              placeholder='Örn: İstanbul'
              {...formik.getFieldProps('province')}
            />
            {formik.touched.province && formik.errors.province && (
              <div className='invalid-feedback'>{formik.errors.province}</div>
            )}
          </div>

          <label className='form-label fw-bold required'>İlçe</label>
          <input
            type='text'
            className={fieldClass('district')}
            placeholder='Örn: Kadıköy'
            {...formik.getFieldProps('district')}
          />
          {formik.touched.district && formik.errors.district && (
            <div className='invalid-feedback'>{formik.errors.district}</div>
          )}
        </div>

        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Lütfen bekleyin...
                <span className='spinner-border spinner-border-sm align-middle ms-2' />
              </span>
            ) : isEditing ? (
              'Güncelle'
            ) : (
              'Kaydet'
            )}
          </button>
        </div>
      </form>
    </Modal>
  )
}
